/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ExtendContainerProps, $Sprite, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$RubyUIText} from '@gongxigames/framework/slotV2/ui/ui-ruby/JSX/RubyUIText';
import {$ButtonRuby} from '../../../../JSX/ButtonRuby';
import {computedDisableMinus, computedDisablePlus} from './etc';

export type BetChangeActionData = '+' | '-';
export type BetChangeAction = (action: BetChangeActionData) => void;

export type BetSelectProps = ExtendContainerProps<{
    label: string;
    betCurrent: number;
    betFormatted: string;
    betList: number[];
    isBuyFeature?: boolean;
    action?: BetChangeAction;
}>;

const SCALE = 0.88;

export const $BetSelect: FC<BetSelectProps> = (props) => {
    const disableMinus = computedDisableMinus(props);
    const disablePlus = computedDisablePlus(props);

    return <$Container
        {...props}
    >
        <$Sprite texture='bet_bg_sys_ui' anchor={0.5}/>
        <$RubyUIText
            text={props.betFormatted}
            maxWidth={90*3}
            stylePreset='PANEL_VAL'
            style={{fontSize: 14*3}}
            name='value'
            responsive={{box: {y: '-16px'}}}
        />
        <$RubyUIText
            localeID={props.label}
            stylePreset='PANEL_VAL_NAME'
            name={props.label}
            responsive={{box: {y: '22px'}}}
        />
        <$ButtonRuby
            disabled={disablePlus}
            icon='btn_icon_plus'
            bg='round_btn_bg'
            responsive={{scale: SCALE, box: {x: `${204/SCALE}px`}}}
            hitArea='round'
            action={() => getProp(props.action)?.('+')}
        />
        <$ButtonRuby
            disabled={disableMinus}
            icon='btn_icon_minus'
            bg='round_btn_bg'
            responsive={{scale: SCALE, box: {x: `${-204/SCALE}px`}}}
            hitArea='round'
            action={() => getProp(props.action)?.('-')}
        />
    </$Container>;
};